import { hasOneCodepoint } from "./codePointLength";

export function isInputCaseSensitive(input: string) {
  if (input.length === 0) {
    return false;
  }

  if (hasOneCodepoint(input)) {
    return input.toLowerCase() !== input.toUpperCase();
  }

  return input !== input.toLowerCase() && input !== input.toUpperCase();
}
